import React from "react";
import { useAuthState } from "../../components/AuthProvider";
import Container from "../../components/Container";
import Content from "../../components/Content";
import DefaultBreadcrumbs from "../../components/DefaultBreadcrumbs";
import Flex from "../../components/Flex";
import Layout from "../../components/Layout";
import { useHistory } from "react-router-dom";
import Card from "./ReviewQueueCard";
import { useMessageToast } from "../../components/MessageProvider";
import Loader from "../../components/Loader";
import {
  fetchReviewQueueCountData,
  fetchBulkOrgData,
  fetchClientSubscriptionsData
} from "../../utils/fetchData";
import { isReviewQueueSubscribed } from "../../utils/functionUtils";
import { isImdmClient } from "../../utils/isImdmClient";
import ProgressBar from "@ramonak/react-progress-bar";
import DateTimePicker from "react-datetime-picker";
import { Multiselect } from "multiselect-react-dropdown";

import LinkButton from "../../components/LinkButton";
import CheckBox from "../../components/CheckBox";
import DataTable from "../NewSearchRecords/DataTable";
import fetchConfig from "../../utils/fetchConfig";
import handleFetchResponse from "../../utils/handleFetchResponse";
import ModalPopup from "../../components/ModalPopup";
import ButtonList from "../../components/ButtonList";
import Button from "../../components/Button";
import TextBox from "../../components/TextBox";
import DropDownList from "../../components/DropDownList";
import { Formik } from "formik";
import * as Yup from "yup";
import Label from "../../components/Label";
import Spinner from "../../components/Loader/Spinner";
import { checkReadOnlyUser } from "../../utils/checkReadOnlyUser.js";

import styles from "./ReviewQueueDashboard.module.scss";
import Icon from "../../components/Icon";
import SecondaryTooltip from "../../components/SecondaryTooltip";
import { type } from "os";
import handleResponse from "../../utils/handleFetchResponse";

const Dashboard = () => {
  const history = useHistory();
  const { user } = useAuthState();
  const {
    selectedClient: { oid: clientId, id, name }
  } = user.preferences;
  const [loading, setLoading] = React.useState(false);
  const [reviewQueueCount, setReviewQueueCount] = React.useState(null);
  const [
    assignedReviewQueueResults,
    setAssignedReviewQueueResults
  ] = React.useState(null);
  const [idSpecQuarantineCount, setIDSpecQuarantineCount] = React.useState(0);
  const [assignedRQList, setAssignedRQList] = React.useState([]);
  const [clientSubscriptionUrl, setClientSubscriptionUrl] = React.useState(
    null
  );
  const [showDialog, setShowDialog] = React.useState(false);
  const [
    showOverlaysReportDialog,
    setShowOverlaysReportDialog
  ] = React.useState(false);

  const [
    showQuarantineReportDialog,
    setShowQuarantineReportDialog
  ] = React.useState(false);

  const [rqConfig, setRqConfg] = React.useState([]);
  const [showUploadFileModal, setShowUploadFileModal] = React.useState(false);
  const [showProgressModal, setShowProgressModal] = React.useState(false);
  const [selectedRQName, setSelectedRQName] = React.useState("");
  const [selectedRQDesc, setSelectedRQDesc] = React.useState("");
  const [progressCompleted, setProgressCompleted] = React.useState(0);
  const [invalidGids, setInvalidGids] = React.useState([]);
  const [failedGids, setFailedGids] = React.useState([]);
  const [unverifiedGids, setUnverifiedGids] = React.useState([]);
  const [duplicateGids, setDuplicateGids] = React.useState([]);
  const [emptyFileErr, setEmptyFileErr] = React.useState(false);
  const [maxLimitErr, setMaxLimitErr] = React.useState(false);
  const [rqItems, setRqItems] = React.useState([]);
  const [isRecordCombinerPresent, setIsRecordCombinerPresent] = React.useState(
    false
  );
  const [isQuarantineEnabled, setIsQuarantineEnabled] = React.useState(false);
  const [
    assignedRQTableLoadingState,
    setAssignedRQTableLoadingState
  ] = React.useState(false);

  const moment = require("moment-timezone");

  const [beginDateValue, setBeginDateValue] = React.useState(new Date());
  const [endDateValue, setEndDateValue] = React.useState(new Date());

  const onBeginDateChange = React.useCallback(date => {
    setBeginDateValue(date);
  }, []);
  const onEndDateChange = React.useCallback(date => {
    setEndDateValue(date);
  }, []);

  const multiselectRef = React.createRef();
  const quarantineSourceMultiselectRef = React.createRef();
  const quarantineMultiselectRef = React.createRef();
  const quarantineType = user.rq_type;

  const [
    selectedSourceForOverlaysReport,
    setSelectedSourceForOverlaysReport
  ] = React.useState(
    ["1.2.3.4.5.6.7.8", "0.2.16", "1.3.1.3"].includes(
      user.preferences.selectedClient.oid
    )
      ? ["All CDB Sources"]
      : []
  );

  const [
    selectedSourceForQuarantineReport,
    setSelectedSourceForQuarantineReport
  ] = React.useState(
    ["1.2.3.4.5.6.7.8", "0.2.16", "1.3.1.3"].includes(
      user.preferences.selectedClient.oid
    ),
    []
  );

  const [selectedQuarantineTypes, setSelectedQuarantineTypes] = React.useState(
    ""
  );

  const [overlayModel, setOverlayModel] = React.useState("all");
  const [
    quarantineClassification,
    setQuarantineClassification
  ] = React.useState("Hard");

  const { selectedClient } = user.preferences;
  const isImdm =
    isImdmClient(selectedClient) ||
    user.preferences.selectedClient.oid === "1.2.3.4.5.6.7.8"; // to enable for imdm test client
  const MAX_LIMIT = 1000;
  const BATCH_SIZE = 10;

  const toast = useMessageToast();
  let fileReader;

  const assignedRQEnterHandler = row => {
    if (row.values.identities === 0) {
      toast.error(`${row.values.name} does not contain any review queue item`);
    } else {
      history.push({
        pathname: `review-queue-dashboard/UploadableReviewQueue/${row.original.id}`,
        state: {
          category: "assignedReviewQueue",
          name: row.values.name
        }
      });
    }
  };

  const enterQueueCell = ({ row }) => {
    return (
      <LinkButton
        icon="arrow_wtail_right_bold"
        onClick={() => {
          assignedRQEnterHandler(row);
        }}
      />
    );
  };

  const addRQItemsCell = ({ row }) => {
    return (
      <LinkButton
        icon="add"
        onClick={() => {
          setSelectedRQName(row.original.name);
          setSelectedRQDesc(row.original.description);
          setShowUploadFileModal(true);
        }}
      />
    );
  };

  const EditableCell = ({ row, cell: { value, column } }) => {
    const initialValue = value || "";
    const [changedValue, setChangedValue] = React.useState(value || "");

    const updateReviewQueue = () => {
      const url = `${process.env.REACT_APP_CLIENT_CONFIG_API_DOMAIN}/review_queues/${row.original.id}/`;
      // const urlLocal = `http://localhost:8000/api/review_queues/${row.original.id}/`;

      let data = {
        client_subscription: clientSubscriptionUrl,
        category: "assignedReviewQueue",
        type: "UploadableReviewQueue"
      };

      data[column.id] = changedValue;
      if (column.id === "description") {
        data["name"] = row.values.name;
      }

      const config = {
        method: "PUT",
        credentials: "include",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json"
        }
      };
      fetch(url, config)
        .then(handleFetchResponse)
        .then(response => {
          toast.info(
            `Update of ${column.id} was successful for ${row.original.name}`
          );
          fetchAssignedRQ();
        })
        .catch(e => {
          fetchAssignedRQ();
          console.log(e);
          toast.error(`Failed to update ${column.id} for ${row.original.name}`);
        });
    };

    const onChange = e => {
      if (!checkReadOnlyUser(user)) setChangedValue(e.target.value);
    };

    const onBlur = () => {
      if (!(initialValue === changedValue)) {
        updateReviewQueue();
      }
    };

    return (
      <div className={styles.editableCellPrent}>
        <input
          className={styles.editableCell}
          type="text"
          value={changedValue}
          onChange={onChange}
          onBlur={onBlur}
          size="50"
        />
      </div>
    );
  };

  const dateCell = ({ row }) => {
    return (
      <span>
        {moment(row.values.created_at)
          .tz(user.preferences.timeZone)
          .format("L, LTS z")}
      </span>
    );
  };

  let columns = [
    {
      Header: "Enter Queue",
      accessor: "enterQueue",
      Cell: enterQueueCell
    },
    {
      Header: "Append To Queue",
      accessor: "appendToQueue",
      Cell: addRQItemsCell
    },
    {
      Header: "RQ Title",
      accessor: "name",
      Cell: EditableCell
    },
    {
      Header: "Description",
      accessor: "description",
      Cell: EditableCell
    },
    {
      Header: "Identities",
      accessor: "identities"
    },
    {
      Header: "Creator",
      accessor: "created_by"
    },
    {
      Header: "Date Created",
      accessor: "created_at",
      Cell: dateCell
    },
    {
      Header: "Last Modified",
      accessor: "updated_at",
      Cell: ({ row }) => {
        return (
          <span>
            {moment(row.values.updated_at)
              .tz(user.preferences.timeZone)
              .format("L, LTS z")}
          </span>
        );
      }
    },
    {
      Header: "Modified By",
      accessor: "updated_by"
    }
  ];

  if (checkReadOnlyUser(user)) {
    columns = columns.filter(ele => {
      return ele.Header !== "Append To Queue";
    });
  }

  const handleFileRead = e => {
    setEmptyFileErr(false);
    setMaxLimitErr(false);
    const content = fileReader.result;
    setRqItems(content.split(/\r\n|\r|\n|,/).filter(a => a));
  };

  const handleFileChosen = file => {
    fileReader = new FileReader();
    fileReader.onloadend = handleFileRead;
    fileReader.readAsText(file);
  };

  const addRQItems = React.useCallback(
    index => {
      const data = {
        gids: rqItems.slice(
          index * BATCH_SIZE,
          (index + 1) * BATCH_SIZE < rqItems.length
            ? (index + 1) * BATCH_SIZE
            : rqItems.length
        )
      };
      const url = `${process.env.REACT_APP_CLIENT_CONFIG_API_DOMAIN}/rpc/add_review_queue_items/?client_id=${clientId}&rq_name=${selectedRQName}`;
      const mockUrl = `/reviewQueueItems.json`;
      const config = {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json"
        }
      };
      fetch(...fetchConfig(url, mockUrl, config))
        .then(handleFetchResponse)
        .then(response => {
          setProgressCompleted(prevState => {
            return prevState + (data.gids.length * 100) / rqItems.length;
          });
          setInvalidGids(prevState => {
            return [...prevState, ...response.invalid_gids];
          });
          setFailedGids(prevState => {
            return [...prevState, ...response.failed_gids];
          });
          setUnverifiedGids(prevState => {
            return [...prevState, ...response.unverified_gids];
          });
          setDuplicateGids(prevState => {
            return [...prevState, ...response.duplicate_gids];
          });
        })
        .catch(e => {
          toast.error("Failed to add Review Queue Items");
        });
    },
    [clientId, toast, rqItems, selectedRQName]
  );

  const fetchClientSubscriptionUrl = React.useCallback(() => {
    const url = `${process.env.REACT_APP_CLIENT_CONFIG_API_DOMAIN}/client_subscriptions/?client__oid=${clientId}`;
    const mockUrl = `/clientSubscription.json`;
    const config = {
      method: "GET"
    };
    fetch(...fetchConfig(url, mockUrl, config))
      .then(handleFetchResponse)
      .then(response => {
        setClientSubscriptionUrl(response.results[0].url);
      })
      .catch(e => {
        toast.error("Failed to fetch client subscription url!");
      });
  }, [clientId, toast]);

  const assignedReviewQueueCount = React.useCallback(
    (rqList = []) => {
      rqList.forEach(
        arr => (arr.identities = assignedReviewQueueResults[arr.name])
      );
      setAssignedRQList([...rqList]);
      setAssignedRQTableLoadingState(false);
    },
    [clientId, assignedReviewQueueResults, toast]
  );

  const fetchAssignedRQ = React.useCallback(() => {
    setAssignedRQTableLoadingState(true);
    const url = `${process.env.REACT_APP_CLIENT_CONFIG_API_DOMAIN}/review_queues/?client_subscription__client_id=${id}&category=assignedReviewQueue`;
    // const urlLocal = `http://localhost:8000/api/review_queues/?client_subscription__client_id=${id}&category=assignedReviewQueue`;
    const mockUrl = `/assignedRQList.json`;
    const config = {
      method: "GET"
    };
    fetch(...fetchConfig(url, mockUrl, config))
      .then(handleFetchResponse)
      .then(response => {
        assignedReviewQueueCount(response.results);
        setAssignedRQTableLoadingState(false);
      })
      .catch(e => {
        console.log(`Assigned Review Queue does not exist for client ${name}`);
        setAssignedRQTableLoadingState(false);
      });
  }, [id, toast, assignedReviewQueueCount, name]);

  const fetchQuarantineIDSpecReviewQueueCountData = React.useCallback(() => {
    const url = `${process.env.REACT_APP_CLIENT_IDENTITY_SERVICE_DOMAIN}/patient/quarantine/count`;
    const mockUrl = `/quarantineCount.json`;
    const config = {
      method: "GET",
      credentials: "include",
      headers: {
        clientId: clientId,
        "Content-Type": "application/json"
      }
    };
    fetch(...fetchConfig(url, mockUrl, config))
      .then(handleResponse)
      .then(response => {
        if (response.data) {
          setIDSpecQuarantineCount(response.data.count);
        }
      })
      .catch(error => {
        toast.error("Failed to fetch quarantine overlay counts");
      });
  }, [clientId, toast]);

  const createReviewQueue = data => {
    const mockUrl = `/createRQ.json`;
    const url = `${process.env.REACT_APP_CLIENT_CONFIG_API_DOMAIN}/review_queues/`;
    // const urlLocal = `http://localhost:8000/api/review_queues/`;

    const config = {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json"
      }
    };
    fetch(...fetchConfig(url, mockUrl, config))
      .then(handleFetchResponse)
      .then(response => {
        setShowDialog(false);
        fetchAssignedRQ();
      })
      .catch(e => {
        setShowDialog(false);
        toast.error("Failed to create Review Queue!");
      });
  };

  const BatchingAddRQItems = () => {
    if (rqItems.length <= MAX_LIMIT) {
      if (rqItems.length === 0) {
        setEmptyFileErr(true);
      } else {
        setShowProgressModal(true);
        setShowUploadFileModal(false);
        for (let i = 0; i < rqItems.length / BATCH_SIZE; i++) {
          addRQItems(i);
        }
      }
    } else setMaxLimitErr(true);
  };

  const ResetAddRQItemStates = () => {
    setSelectedRQName("");
    setSelectedRQDesc("");
    setProgressCompleted(0);
    setInvalidGids([]);
    setFailedGids([]);
    setUnverifiedGids([]);
    setDuplicateGids([]);
    setShowProgressModal(false);
    setRqItems([]);
    setMaxLimitErr(false);
    setEmptyFileErr(false);
    fetchAssignedRQ();
  };

  const downloadSampleFile = () => {
    let sampleFile =
      "679326a0-4bfa-4538-87c9-4f16ae83e977,\nfdf3b3ae-04c4-4c18-be7a-c5db6f1af8c0,\n5c65da06-e061-47ca-9781-a63d62afe597,\nb355aca9-8a00-4747-8aa9-39107e485750,\n578b909c-e4fa-4a23-bab3-8e78e4438fb4,\nd374f0ce-d6d7-453d-8140-300faa6240df\nfddcaf18-21da-41c8-b0f8-63799cfbc59f,\n89c1b93c-5e24-4136-bfa0-61122ed7f859,\n4f399de4-1737-4993-b3bc-7620550dd8aa,\n591d80df-be58-427c-b575-6ff777b0a95f,\nc6e66d03-7087-41e8-90a0-8c48edff9503,\nc74de481-f2e2-48ab-a6f3-16095e7357c4,\n76e77cd5-32b5-4772-b770-ba90a8b95c9c,\nad7b6bf6-9c04-4741-83ef-c1a3cad105ee,\n567e00da-55ee-4474-8a5e-a5cdee68db4c,\nb3052ca4-ce58-4fb6-b692-21a12b52123e,\n9ff89321-3d14-45b9-a558-30d648dec91b,\n6523d96d-a02b-44fc-9ee0-4b617c63861f,\n0ddca0aa-80f5-44a5-8a24-d83cca959903";
    const url = URL.createObjectURL(
      new Blob([sampleFile], { type: "text/csv" })
    );
    window.location.href = url;
  };

  const generateCsvLink = () => {
    let strCsv = "";
    if (invalidGids.length !== 0) {
      strCsv += "Invalid Golden Ids\n";
      invalidGids.forEach(invalidGid => {
        strCsv += invalidGid + "\n";
      });
      strCsv += "\n";
    }

    if (failedGids.length !== 0) {
      strCsv += "Failed Golden Ids\n";
      failedGids.forEach(failedGid => {
        strCsv += failedGid + "\n";
      });
      strCsv += "\n";
    }

    if (unverifiedGids.length !== 0) {
      strCsv += "Unverified Gids\n";
      unverifiedGids.forEach(unverifiedGid => {
        strCsv += unverifiedGid + "\n";
      });
      strCsv += "\n";
    }

    if (duplicateGids.length !== 0) {
      strCsv += "Duplicate Gids\n";
      duplicateGids.forEach(duplicateGid => {
        strCsv += duplicateGid + "\n";
      });
      strCsv += "\n";
    }

    const url = URL.createObjectURL(new Blob([strCsv], { type: "text/csv" }));
    window.location.href = url;
  };

  const generateDownloadableOverlayReportInCSV = overlayReportObject => {
    let strCsv = "";
    strCsv +=
      "Task Creation Time,Member Modification Time,Record ID,Source:ID,Legal Name,Street Address,Gender,DOB";
    strCsv += "\n";

    if (overlayReportObject.result.length !== 0) {
      overlayReportObject.result.forEach(overlayRecordObject => {
        for (let key in overlayRecordObject) {
          if (key === "source_entity_id") {
            overlayRecordObject[key] = overlayRecordObject[key] + "\t";
          }

          strCsv += '"' + overlayRecordObject[key] + '"' + ",";
        }
        strCsv += "\n";
      });
    }
    const url = URL.createObjectURL(new Blob([strCsv], { type: "text/csv" }));
    let fileLink = document.createElement("a");
    fileLink.href = url;
    fileLink.download = "Overlays_Report";
    fileLink.click();
    // window.location.href = url;
  };

  const generateDownloadableQuarantineReportInCSV = quarantineReportObject => {
    let strCsv = "";
    strCsv +=
      "Task Creation Time,Task Update Time,Record ID,Source ID,Type,Severity";
    strCsv += "\n";

    if (quarantineReportObject.data.length !== 0) {
      quarantineReportObject.data.forEach(quarantineReportObject => {
        for (let key in quarantineReportObject) {
          if (key === "sourceEntityId") {
            quarantineReportObject[key] = quarantineReportObject[key] + "\t";
          }
          strCsv +=
            '"' +
            (key === "originalIngestionTime" || key === "lastUpdatedTime"
              ? moment
                  .unix(quarantineReportObject[key] / 1000)
                  .utc()
                  .format()
              : quarantineReportObject[key]) +
            '"' +
            ",";
        }
        strCsv += "\n";
      });
    }
    const url = URL.createObjectURL(new Blob([strCsv], { type: "text/csv" }));
    let fileLink = document.createElement("a");
    fileLink.href = url;
    fileLink.download = "Quarantine_Report";
    fileLink.click();
    // window.location.href = url;
  };

  const fetchOverlayReport = () => {
    const url = `${process.env.REACT_APP_CLIENT_CONFIG_API_DOMAIN}/rpc/overlay_report/`;
    const localurl = `http://localhost:8000/api/rpc/overlay_report/`;

    const mockUrl = `/overlaysReport.json`;
    const bDate =
      moment(beginDateValue).format("YYYY-MM-DD") + "T00:00:00.000Z";
    const eDate = moment(endDateValue).format("YYYY-MM-DD") + "T23:59:59.000Z";
    const data = {
      client_id: user.preferences.selectedClient.oid,
      //beginDateTime: moment(beginDateValue).tz(user.preferences.timeZone).format("L, LTS z"),
      beginDateTime: bDate,
      endDateTime: eDate,
      sources: selectedSourceForOverlaysReport,
      overlay_models:
        overlayModel && overlayModel !== "all" ? [overlayModel, "all"] : [] // we would need to also fetech overlays common to all models
    };
    const config = {
      //trying to post stringify obj
      method: "POST",
      body: JSON.stringify(data),
      credentials: "include",
      headers: {
        "Content-Type": "application/json"
      }
    };

    fetch(...fetchConfig(url, mockUrl, config))
      .then(handleFetchResponse)
      .then(response => {
        setShowOverlaysReportDialog(false);
        generateDownloadableOverlayReportInCSV(response);
        toast.info("Overlay report successfully fetched");
      })

      .catch(e => {
        setShowOverlaysReportDialog(false);
        toast.error("Failed to download overlays report" + e);
      });
  };

  const fetchQuarantineReport = () => {
    const url = `${process.env.REACT_APP_CLIENT_IDENTITY_SERVICE_DOMAIN}/patient/quarantine/report`;
    const localurl = `http://localhost:8000/api/rpc/quarantine_report/`;
    const mockUrl = `/quarantineReport.json`;
    const bDate =
      moment(beginDateValue, "YYYY-MM-DD")
        .utc()
        .startOf("day")
        .unix() * 1000;
    const eDate =
      moment(endDateValue, "YYYY-MM-DD")
        .utc()
        .startOf("day")
        .add(23, "hours")
        .add(59, "minutes")
        .add(59, "seconds")
        .unix() * 1000;
    const data = {
      types: selectedQuarantineTypes,
      severity: quarantineClassification,
      beginDate: bDate,
      endDate: eDate,
      sources: selectedSourceForQuarantineReport
    };
    const config = {
      method: "POST",
      body: JSON.stringify(data),
      credentials: "include",
      type: quarantineType,
      headers: {
        "Content-Type": "application/json",
        clientId: selectedClient.oid
      }
    };

    fetch(...fetchConfig(url, mockUrl, config))
      .then(handleFetchResponse)
      .then(response => {
        setShowQuarantineReportDialog(false);
        generateDownloadableQuarantineReportInCSV(response);
        toast.info("Quarantine report successfully fetched");
      })
      .catch(e => {
        setShowQuarantineReportDialog(false);
        console.log("Failed to download report: ", e);
        toast.error(
          "Unable to download the quarantine report. The filter criteria might be too broad. Please consider using more specific filter criteria."
        );
      });
  };

  const onSelectOverlayResportingSourcestHandler = () => {
    setSelectedSourceForOverlaysReport(
      multiselectRef.current.getSelectedItems()
    );
  };

  const onSelectQuarantineResportingSourcestHandler = () => {
    setSelectedSourceForQuarantineReport(
      quarantineSourceMultiselectRef.current.getSelectedItems()
    );
  };

  const onSelectQuarantineTypeHandler = () => {
    setSelectedQuarantineTypes(
      quarantineMultiselectRef.current.getSelectedItems()
    );
  };

  const fetchAllSourcesFlatArray = quarantine => {
    const allSourcesIMDM = user.preferences.sources;
    const sourceCodes = [];
    if (allSourcesIMDM != null) {
      Object.keys(allSourcesIMDM).forEach(key => sourceCodes.push(key));
    }
    if (
      ["1.2.3.4.5.6.7.8", "0.2.16", "1.3.1.3", "0.2.16.2"].includes(
        //overlay true ,qua -false
        user.preferences.selectedClient.oid
      )
    ) {
      sourceCodes.unshift("All CDB Sources");
    }

    if (quarantine) {
      sourceCodes.unshift("All Sources");
    }
    return sourceCodes; //based on model cond
  };

  const viewQuarantineReport = () => {
    const dashboard_domain =
      process.env.REACT_APP_DATA_QUALITY_DASHBOARD_DOMAIN;
    window.open(dashboard_domain, "_blank", "noopener,noreferrer");
    setShowQuarantineReportDialog(false);
  };

  const rqReportDownloadHandler = () => {
    return (
      <ModalPopup
        open={showOverlaysReportDialog}
        onClose={() => setShowOverlaysReportDialog(false)}
      >
        <div>
          <div style={{ width: "30rem" }}>
            <div className={styles.rqReport}>
              <div className={styles.rqReportHeading}>Overlays Report</div>

              <div className={styles.rqReportCalender}>
                <div className={styles.sourceMultiSelect}>
                  <Multiselect
                    options={fetchAllSourcesFlatArray(false)}
                    ref={multiselectRef}
                    isObject={false}
                    displayValue="sourceCode"
                    placeholder="Select source(s)"
                    selectedValues={selectedSourceForOverlaysReport}
                    closeOnSelect={true}
                    onSelect={() => onSelectOverlayResportingSourcestHandler()}
                    onRemove={() => onSelectOverlayResportingSourcestHandler()}
                    style={{
                      searchBox: {
                        backgroundColor: "white",
                        border: "1px solid grey",
                        borderRadius: "1.5rem",
                        paddingTop: "0.5rem",
                        paddingLeft: "0.5rem"
                      },
                      alignItem: "center"
                    }}
                    showArrow={true}
                  />
                </div>

                <span className={styles.text}>
                  Select a date range between which Overlays report is required
                </span>

                <div className={styles.date}>
                  <div className={styles.text}>Begin Date :</div>
                  <div className={styles.dateSelector}>
                    <DateTimePicker
                      onChange={onBeginDateChange}
                      value={beginDateValue}
                      format="y-MM-dd"
                    />
                  </div>
                </div>

                <div className={styles.date}>
                  <div className={styles.text}>End Date :</div>
                  <div className={styles.dateSelector}>
                    <DateTimePicker
                      onChange={onEndDateChange}
                      value={endDateValue}
                      format="y-MM-dd"
                    />
                  </div>
                </div>
                {/* {console.log((endDateValue - beginDateValue)/86400000)} */}
                {/* {console.log((endDateValue)/86400000)} */}

                {(endDateValue - beginDateValue < 0 ||
                  (endDateValue - beginDateValue) / 86400000 > 7) &&
                  endDateValue !== 0 &&
                  beginDateValue !== 0 && (
                    <div className={styles.dateValidationText}>
                      {" "}
                      Select a valid date range of a maximum 7 days
                    </div>
                  )}
                {isImdm ? (
                  <div className={styles.rqReportCalender}>
                    <span className={styles.text}>Select Overlay Model</span>
                    <div
                      onChange={e => setOverlayModel(e.target.value)}
                      className={styles.overlaModelRadio}
                    >
                      <input
                        type="radio"
                        value="all"
                        key="all"
                        name="overlayModel"
                        checked={overlayModel == "all"}
                      />
                      Both
                      <input
                        type="radio"
                        value="actual"
                        key="actual"
                        name="overlayModel"
                        checked={overlayModel == "actual"}
                      />
                      Original
                      <input
                        type="radio"
                        value="experimental"
                        key="experimental"
                        name="overlayModel"
                        checked={overlayModel == "experimental"}
                      />
                      Experimental(New)
                    </div>
                  </div>
                ) : null}
                <div style={{ marginTop: "2rem" }}>
                  <ButtonList>
                    <Button onClick={() => setShowOverlaysReportDialog(false)}>
                      Cancel
                    </Button>
                    <Button
                      primary
                      type="submit"
                      disabled={selectedSourceForOverlaysReport.length <= 0}
                      onClick={() => fetchOverlayReport()}
                    >
                      Download Report
                    </Button>

                    {/* <Button
                      primary
                      type="submit"
                      onClick={() => fetchQuarantineReport()}
                    >
                      Download Report
                    </Button> */}
                  </ButtonList>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ModalPopup>
    );
  };

  const quarantineReportHandler = () => {
    return (
      <ModalPopup
        open={showQuarantineReportDialog}
        onClose={() => setShowQuarantineReportDialog(false)}
      >
        {/* <div> */}
        <body>
          <div style={{ width: "30rem" }}>
            <div className={styles.rqReport}>
              <div className={styles.rqReportHeading}>Quarantine Report</div>

              <div className={styles.rqReportCalender}>
                <div className={styles.sourceMultiSelect}>
                  <Multiselect
                    options={fetchAllSourcesFlatArray(true)}
                    ref={quarantineSourceMultiselectRef}
                    isObject={false}
                    displayValue="sourceCode"
                    placeholder="Select source(s)" //add another placeholder fro quarantine types
                    //placeholderForQuarantineType="Select quarantine types"

                    selectedValues={selectedSourceForQuarantineReport}
                    closeOnSelect={true}
                    onSelect={() =>
                      onSelectQuarantineResportingSourcestHandler()
                    }
                    onRemove={() =>
                      onSelectQuarantineResportingSourcestHandler()
                    }
                    style={{
                      searchBox: {
                        backgroundColor: "white",
                        border: "1px solid grey",
                        borderRadius: "1.5rem",
                        paddingTop: "0.5rem",
                        paddingLeft: "0.5rem"
                      },
                      alignItem: "center"
                    }}
                    showArrow={true}
                  />
                </div>

                <div className={styles.sourceMultiSelect}>
                  <Multiselect
                    options={[
                      "ProblematicOverlay",
                      "Failure",
                      "OverMerge",
                      "Insufficient",
                      "All"
                    ]}
                    ref={quarantineMultiselectRef}
                    isObject={false}
                    displayValue="type"
                    placeholder="Select type"
                    selectedValues={selectedQuarantineTypes}
                    closeOnSelect={true}
                    onSelect={() => onSelectQuarantineTypeHandler()}
                    onRemove={() => onSelectQuarantineTypeHandler()}
                    style={{
                      searchBox: {
                        backgroundColor: "white",
                        border: "1px solid grey",
                        borderRadius: "1.5rem",
                        paddingTop: "0.5rem",
                        paddingLeft: "0.5rem"
                      },
                      alignItem: "center"
                    }}
                    showArrow={true}
                  />
                </div>

                <div className={styles.date}>
                  <div className={styles.text}>Begin Date :</div>
                  <div className={styles.dateSelector}>
                    <DateTimePicker
                      onChange={onBeginDateChange}
                      value={beginDateValue}
                      format="y-MM-dd"
                    />
                  </div>
                </div>

                <div className={styles.date}>
                  <div className={styles.text}>End Date :</div>
                  <div className={styles.dateSelector}>
                    <DateTimePicker
                      onChange={onEndDateChange}
                      value={endDateValue}
                      format="y-MM-dd"
                    />
                  </div>
                </div>
                {/* {console.log((endDateValue - beginDateValue)/86400000)} */}
                {/* {console.log((endDateValue)/86400000)} */}

                {(endDateValue - beginDateValue < 0 ||
                  (endDateValue - beginDateValue) / 86400000 > 7) &&
                  endDateValue !== 0 &&
                  beginDateValue !== 0 && (
                    <div className={styles.dateValidationText}>
                      {" "}
                      Select a valid date range of a maximum 7 days
                    </div>
                  )}

                <div className={styles.rqReportCalender}>
                  <span className={styles.text}>Select classification</span>
                  <div
                    onChange={e => setQuarantineClassification(e.target.value)}
                    className={styles.overlaModelRadio}
                  >
                    <input
                      type="radio"
                      value="Hard"
                      key="Hard"
                      name="quarantineClassification"
                      checked={quarantineClassification == "Hard"}
                    />
                    Hard
                    <input
                      type="radio"
                      value="Potential"
                      key="Potential"
                      name="quarantineClassification"
                      checked={quarantineClassification == "Potential"}
                    />
                    Potential
                    <input
                      type="radio"
                      value="Both"
                      key="Both"
                      name="quarantineClassification"
                      checked={quarantineClassification == "Both"}
                    />
                    Both
                  </div>
                </div>

                <div style={{ marginTop: "2rem" }}>
                  <ButtonList>
                    <Button
                      onClick={() => setShowQuarantineReportDialog(false)}
                    >
                      Cancel
                    </Button>
                    <Button
                      primary
                      type="submit"
                      disabled={
                        selectedQuarantineTypes.length <= 0 ||
                        selectedSourceForQuarantineReport.length <= 0
                      }
                      onClick={() => fetchQuarantineReport()}
                    >
                      Download Report
                    </Button>
                    <Button
                      primary
                      type="submit"
                      onClick={() => viewQuarantineReport()}
                    >
                      View Dashboard
                    </Button>
                  </ButtonList>
                </div>
              </div>
            </div>
          </div>
          {/* </div> */}
        </body>
      </ModalPopup>
    );
  };

  React.useEffect(() => {
    window.scrollTo(0, 0);
    setLoading(true);
    Promise.all([
      fetchReviewQueueCountData(clientId),
      fetchBulkOrgData(clientId),
      fetchClientSubscriptionsData(clientId)
    ])
      .then(responses => {
        setLoading(false);
        if (responses[0].results) {
          setReviewQueueCount(responses[0].results.dynamicReviewQueue);
          setAssignedReviewQueueResults(
            responses[0].results.assignedReviewQueue
          );
        }
        if (responses[1].length > 0) {
          setRqConfg(
            responses[1][0].clients[0].client_subscriptions[0].reviewQueues
          );
          if (
            responses[1][0].clients[0].client_subscriptions[0].quarantine.some(
              item =>
                item.name === "ProblematicOverlay" &&
                ((item.enable !== undefined && item.enable === true) ||
                  item.classification !== undefined)
            )
          ) {
          }
          if (
            responses[1][0].clients[0].client_subscriptions[0].quarantine.some(
              item => item.enable === true
            )
          ) {
            setIsQuarantineEnabled(true);
          }
        }
        if (responses[2].results[0].record_combiner_client_sub_relations) {
          setIsRecordCombinerPresent(true);
        } else setIsRecordCombinerPresent(false);
      })
      .catch(e => {
        toast.error("Failed to review queue counts");
        console.error("Error details:", e);
        setLoading(false);
      });
  }, [clientId, toast]);

  React.useEffect(() => {
    fetchAssignedRQ();
  }, [fetchAssignedRQ]);

  React.useEffect(() => {
    fetchClientSubscriptionUrl();
  }, [fetchClientSubscriptionUrl]);

  React.useEffect(() => {
    fetchQuarantineIDSpecReviewQueueCountData();
  }, [clientId]);

  return (
    <Layout>
      <Container>
        {/* {filterCDBSources()} */}
        <Flex gutter={3}>
          <Flex.Item span={12}>
            <DefaultBreadcrumbs />
          </Flex.Item>
          <Flex.Item span={12}>
            <Content>
              <h3>Review Queue Dashboard</h3>
              <p>
                Review queues are curated lists that would possibly require a
                manual review to verify if partitioning or grouping was done
                correctly by the system.
              </p>
            </Content>
          </Flex.Item>
          {isReviewQueueSubscribed(rqConfig, "NearMissReviewQueue") ||
          isReviewQueueSubscribed(rqConfig, "TwinsReviewQueue") ||
          isReviewQueueSubscribed(rqConfig, "IMDMNearMatchReviewQueue") ||
          isReviewQueueSubscribed(rqConfig, "OverlayReviewQueue") ||
          isReviewQueueSubscribed(rqConfig, "CollisionDetectionReviewQueue") ? (
            // remove below comment
            //  {true ? (
            <div className={styles.rqCard}>
              {/* <Flex.Item> */}
              <Loader loading={loading}>
                {isReviewQueueSubscribed(
                  rqConfig,
                  "CollisionDetectionReviewQueue"
                ) && (
                  <div className={styles.rqCardItem}>
                    <Card
                      name="Collision Review Queue"
                      isLoading={loading}
                      noOfQueues={
                        reviewQueueCount
                          ? reviewQueueCount.CollisionDetectionReviewQueue
                          : "-"
                      }
                      onClick={() => {
                        history.push({
                          pathname:
                            "review-queue-dashboard/CollisionDetectionReviewQueue",
                          state: {
                            category: "dynamicReviewQueue"
                          }
                        });
                      }}
                    />
                  </div>
                )}

                {isReviewQueueSubscribed(
                  rqConfig,
                  "IMDMNearMatchReviewQueue"
                ) && (
                  // remove below comment
                  // {true
                  <div className={styles.rqCardItem}>
                    <Card
                      name="Possible Over Merge"
                      isLoading={loading}
                      noOfQueues={
                        reviewQueueCount
                          ? reviewQueueCount.IMDMNearMatchReviewQueue
                          : "-"
                      }
                      onClick={() => {
                        history.push({
                          pathname:
                            "review-queue-dashboard/IMDMNearMatchReviewQueue",
                          state: {
                            category: "dynamicReviewQueue"
                          }
                        });
                      }}
                    />
                  </div>
                )}

                {isReviewQueueSubscribed(rqConfig, "NearMissReviewQueue") && (
                  <div className={styles.rqCardItem}>
                    <Card
                      name="Near Misses"
                      isLoading={loading}
                      noOfQueues={
                        reviewQueueCount
                          ? reviewQueueCount.NearMissReviewQueue
                          : "-"
                      }
                      onClick={() => {
                        history.push({
                          pathname:
                            "review-queue-dashboard/NearMissReviewQueue",
                          state: {
                            category: "dynamicReviewQueue"
                          }
                        });
                      }}
                    />
                  </div>
                )}

                {isReviewQueueSubscribed(rqConfig, "TwinsReviewQueue") && (
                  <div className={styles.rqCardItem}>
                    <Card
                      name="Twins"
                      isLoading={loading}
                      noOfQueues={
                        reviewQueueCount
                          ? reviewQueueCount.TwinsReviewQueue
                          : "-"
                      }
                      onClick={() => {
                        history.push({
                          pathname: "review-queue-dashboard/TwinsReviewQueue",
                          state: {
                            category: "dynamicReviewQueue"
                          }
                        });
                      }}
                    />
                  </div>
                )}

                {isRecordCombinerPresent && (
                  <div className={styles.rqCardItem}>
                    <Card
                      name="Overlay"
                      isLoading={loading}
                      cardType="Records"
                      noOfQueues={
                        reviewQueueCount
                          ? reviewQueueCount.OverlayReviewQueue
                          : "-"
                      }
                      onClick={() => {
                        history.push({
                          pathname: "/RecordOverlayReviewQueue/OverlayRecord",
                          state: {
                            category: "dynamicReviewQueue"
                          }
                        });
                      }}
                      searchOverlay={true}
                      onClickSearch={(sourceEntityId, sourceSystemId) => {
                        history.push({
                          pathname: "/RecordOverlayReviewQueue/OverlayRecord",
                          state: {
                            category: "dynamicReviewQueue",
                            sourceEntityId,
                            sourceSystemId,
                            searchOverlay: true
                          }
                        });
                      }}
                    />
                  </div>
                )}
                {isQuarantineEnabled && (
                  <div className={styles.rqCardItem}>
                    <Card
                      name="Quarantine"
                      isLoading={loading}
                      cardType="Records"
                      noOfQueues={idSpecQuarantineCount}
                      searchOverlay={true}
                      isQuarantine={true}
                      isAllQuarantine={true}
                      onClickSearch={(sourceEntityId, sourceSystemId) => {
                        history.push({
                          pathname: `/search-identities-new/${
                            selectedClient.oid
                          }/quarantine/${encodeURIComponent(
                            sourceSystemId
                          )}/${encodeURIComponent(sourceEntityId)}/`,
                          state: {
                            category: "dynamicReviewQueue",
                            sourceEntityId,
                            sourceSystemId,
                            searchOverlay: true
                          }
                        });
                      }}
                    />
                  </div>
                )}
              </Loader>
              {/* </Flex.Item> */}
            </div>
          ) : (
            <Flex.Item>
              <Loader loading={loading}>
                <h2>Not Subscribed</h2>
              </Loader>
            </Flex.Item>
          )}

          {/* <Flex.Item span={12}>
            <div className={styles.base}>
              <Content>
                <h3>Reports</h3>
              </Content>
              <div className={styles.rqReports}>
                <div className={styles.rqReport}>
                  <LinkButton
                    icon="download"
                    onClick={() => {
                      setShowOverlaysReportDialog(true);
                    }}
                    className={styles.icon}
                  >
                    {" "}
                    Overlays Report
                  </LinkButton>


                </div>
              </div>
            </div>
          </Flex.Item> */}

          <Flex.Item span={12}>
            <div className={styles.base}>
              <Content>
                <h3>Reports</h3>
              </Content>
              <div className={styles.rqReports}>
                <div className={styles.rqReport}>
                  <LinkButton
                    icon="download"
                    onClick={() => {
                      setShowOverlaysReportDialog(true);
                    }}
                    className={styles.icon}
                  >
                    {" "}
                    Overlays Report
                  </LinkButton>
                </div>
                <div className={styles.rqReport}>
                  <LinkButton
                    icon="download"
                    onClick={() => {
                      setShowQuarantineReportDialog(true);
                    }}
                    className={styles.icon}
                  >
                    {" "}
                    Quarantine Report
                  </LinkButton>
                </div>
              </div>
            </div>
          </Flex.Item>
          {rqReportDownloadHandler()}

          {quarantineReportHandler()}

          <Flex.Item span={12}>
            <div className={styles.base}>
              <Content>
                <h3>Assigned Queues</h3>
              </Content>
              <div className={styles.addQueueButton}>
                <LinkButton
                  icon="add"
                  onClick={() => {
                    setShowDialog(true);
                  }}
                  isInvisible={checkReadOnlyUser(user)}
                >
                  {" "}
                  Add Queue
                </LinkButton>
              </div>
            </div>
            {assignedRQTableLoadingState ? (
              <div className={styles.loader}>
                <Spinner />
              </div>
            ) : (
              <div>
                <DataTable
                  columns={columns}
                  data={assignedRQList}
                  hasGlobalFiltering={true}
                />
              </div>
            )}
          </Flex.Item>
        </Flex>
      </Container>
      <ModalPopup open={showDialog} onClose={() => setShowDialog(false)}>
        <Formik
          initialValues={{
            name: "",
            category: "",
            description: ""
          }}
          validationSchema={Yup.object().shape({
            name: Yup.string()
              .trim()
              .required("Name field is required"),
            description: Yup.string()
              .trim()
              .required("Description field is required"),
            category: Yup.string()
              .trim()
              .required("Category field is required")
          })}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            setSubmitting(true);
            let data = {
              name: values.name,
              category: values.category,
              description: values.description,
              updated_by: user.username,
              created_by: user.username,
              type: "UploadableReviewQueue",
              client_subscription: clientSubscriptionUrl
            };
            createReviewQueue(data);
            setSubmitting(false);
          }}
        >
          {({
            values,
            touched,
            errors,
            handleChange,
            handleBlur,
            handleSubmit
          }) => (
            <form onSubmit={handleSubmit}>
              <div style={{ width: "30rem" }}>
                <div style={{ marginBottom: "1rem" }}>
                  <TextBox
                    errorText={touched.name ? errors.name : null}
                    id="name"
                    label={
                      <Label error={touched.name && errors.name} htmlFor="name">
                        <b>Name:</b>
                      </Label>
                    }
                    onChange={handleChange}
                    onBlur={handleBlur}
                    required
                    value={values.name}
                    width="100%"
                  />
                </div>
                <div style={{ marginBottom: "1rem" }}>
                  <TextBox
                    errorText={touched.description ? errors.description : null}
                    id="description"
                    label={
                      <Label
                        error={touched.description && errors.description}
                        htmlFor="description"
                      >
                        <b>Description:</b>
                      </Label>
                    }
                    onChange={handleChange}
                    onBlur={handleBlur}
                    required
                    value={values.description}
                    width="100%"
                  />
                </div>

                <div style={{ marginBottom: "1rem" }}>
                  <DropDownList
                    width="100%"
                    errorText={touched.category ? errors.category : null}
                    id="category"
                    onChange={handleChange}
                    label={
                      <Label
                        error={touched.category && errors.category}
                        htmlFor="category"
                      >
                        <b>Category:</b>
                      </Label>
                    }
                    required
                    value={values.category}
                  >
                    <DropDownList.Item value="">
                      Select Category
                    </DropDownList.Item>
                    <DropDownList.Item value="assignedReviewQueue">
                      Uploadable Review Queue
                    </DropDownList.Item>
                  </DropDownList>
                </div>
              </div>
              <div style={{ marginTop: "2rem" }}>
                <ButtonList>
                  <Button onClick={() => setShowDialog(false)}>Cancel</Button>
                  <Button primary type="submit" onClick={() => {}}>
                    Confirm
                  </Button>
                </ButtonList>
              </div>
            </form>
          )}
        </Formik>
      </ModalPopup>
      <ModalPopup
        open={showUploadFileModal}
        onClose={() => {
          setShowUploadFileModal(false);
        }}
      >
        <h2>{selectedRQName}</h2>
        <p>{selectedRQDesc}</p>
        <div className={styles.uploadFile}>
          <h3>
            Upload File
            <SecondaryTooltip
              toolTipMsg={
                <p className={styles.toolTipMessage}>
                  Upload file which contains all the golden Ids of the
                  aggregates you want to add to this review queue. Download the
                  sample file for more help
                </p>
              }
            >
              <Icon type="info_filled" />
            </SecondaryTooltip>
          </h3>
          <span>
            <input
              type="file"
              accept=".csv"
              onChange={e => handleFileChosen(e.target.files[0])}
            />
            <Button onClick={downloadSampleFile}>
              <div className={styles.downloadSampleFile}>
                <Icon type="download" /> <h6>Download Sample File</h6>
              </div>
            </Button>
          </span>
        </div>
        <div className={styles.buttonBar}>
          {emptyFileErr && (
            <div className={styles.fileErr}>
              Please select a file with a list of Golden Identities to proceed
            </div>
          )}
          {maxLimitErr && (
            <div className={styles.fileErr}>
              You have exceeded the maximum allowed size of {MAX_LIMIT}{" "}
              aggregates
            </div>
          )}
          <ButtonList>
            <Button
              onClick={() => {
                setShowUploadFileModal(false);
                setMaxLimitErr(false);
                setEmptyFileErr(false);
              }}
            >
              Cancel
            </Button>
            <Button primary onClick={BatchingAddRQItems}>
              Confirm
            </Button>
          </ButtonList>
        </div>
      </ModalPopup>
      <ModalPopup open={showProgressModal}>
        <div className={styles.summary}>
          <ProgressBar
            bgColor="#e87722"
            completed={progressCompleted.toPrecision(4)}
            labelAlignment="outside"
            labelColor="black"
          />
          {progressCompleted.toPrecision(4) === "100.0" ? (
            <div className={styles.report}>
              <div className={styles.total}>
                Number of Records : {rqItems.length}
              </div>
              <div className={styles.successful}>
                Successful Uploads :
                {rqItems.length -
                  (invalidGids.length +
                    failedGids.length +
                    unverifiedGids.length +
                    duplicateGids.length)}
              </div>
              <div className={styles.excluded}>
                Excluded :
                {invalidGids.length + failedGids.length + unverifiedGids.length}{" "}
              </div>
              <div className={styles.duplicates}>
                Duplicates : {duplicateGids.length}
              </div>
              <div style={{ marginTop: "2rem" }}>
                <ButtonList>
                  <Button onClick={ResetAddRQItemStates}>Close</Button>
                  <Button onClick={generateCsvLink} primary>
                    <div className={styles.downloadReport}>
                      <Icon type="download" /> <h6>Download Report</h6>
                    </div>
                  </Button>
                </ButtonList>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </ModalPopup>
    </Layout>
  );
};

export default Dashboard;
